import React from 'react'

function Home() {
    return (
        <div className="homePage">
            <div className="container">
                <h1>Welcome to my Portfolio</h1>
                <h2>Software Developer</h2>
                <p>A full-stack software engineer with big-picture, entrepreneurial mindset but meticulously detailed and goal-oriented. I thrive on efficiency and creating logical solutions to add value to the customer experience. As a business and product development manager for over 15 years, I gained a strong foundation in strategizing growth and long-term problem solving through SMART goal planning and team-oriented collaboration. I am passionate about learning, applying and sharing to empower other companies and individuals to a better version than yesterday.</p>
            </div>
        </div>
    )
}

export default Home
